export enum PermissionType {
  canRead = 'Read',
  canUpdate = 'Update',
  canAdminister = 'Administer',
}
